import {
  createSlice,
  createSelector,
  PayloadAction,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import {
  resetSnack,
  successSnack,
  errorSnack,
} from "../snackbar/snackbarSlice";
// import { fetchOrderUserByID } from "../users/usersSlice";

import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

export const fetchInvoices = createAsyncThunk(
  "invoices/fetchInvoices",
  async ({ token, params }, thunkAPI) => {
    try {
      const response = await axios.get(
          `${baseURL}/v1/admin/invoices`,
          {
            headers: { Authorization: `Bearer ${token}` },
            params,
          }
      );

      thunkAPI.dispatch(setLastQuery(params));
      thunkAPI.dispatch(setInvoicesAmount(response.headers["x-total-count"]));
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching Invoices list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreInvoices = createAsyncThunk(
  "invoices/fetchMoreInvoices",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/invoices${args.query}&offset=${args.offset}`,
        config
      );

      // thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(setInvoicesAmount(response.headers["x-total-count"]));

      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
      }
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description ||
        //       'Error fetching products list'
        //   )
        // );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchInvoiceByID = createAsyncThunk(
  "invoices/fetchInvoiceByID",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/invoices/${args.invoiceID}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching invoice data"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const createInvoice = createAsyncThunk(
  "invoices/createInvoice",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await axios.post(
        `${baseURL}/v1/admin/clients/${args.clientID}/invoices`,
        {},
        config
      );
      thunkAPI.dispatch(
        successSnack("Invoice & Purchase Invoices created successfully")
      );

      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error creating Invoice"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const getFullList = createAsyncThunk(
  "products/getFullList",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 25; i++) {
      objToMap.push({
        token: args.token,
        query: args.query,
        offset: args.offset + 25 * i,
      });
    }

    for (const requestData of objToMap) {
      await thunkAPI.dispatch(
        fetchMoreInvoices(requestData)
      );
      await new Promise((r) => setTimeout(r, 30000));
    }
  }
);

const invoicesSlice = createSlice({
  name: "invoices",
  initialState: {
    invoice: {},
    invoicesList: [],
    loading: "idle",
    message: "",
    error: "",
    viewing: false,
    invoicesAmount: "",
    lastQuery: "",
  },
  reducers: {
    setInvoice(state, action) {
      state.invoice = action.payload;
    },
    setViewing(state, action) {
      state.viewing = action.payload;
    },
    setLastQuery: (state, action) => {
      state.lastQuery = action.payload;
    },
    setInvoicesAmount: (state, action) => {
      state.invoicesAmount = action.payload;
    },
    // setInvoiceUser(state, action) {
    //   state.invoiceUser = action.payload;
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchInvoices.pending, (state) => {
      state.invoicesList = [];
      state.invoicesFilter = [];

      // state.loading = "loading";
    });
    builder.addCase(fetchInvoices.fulfilled, (state, { payload }) => {
      state.invoicesList = payload;
      state.invoicesFilter = payload;
      // state.loading = "loaded";
    });
    builder.addCase(fetchInvoices.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchMoreInvoices.fulfilled, (state, { payload }) => {
      state.error = "";
      state.invoicesList = state.invoicesList.concat(payload);
      state.loading = "loaded";
    });
    builder.addCase(fetchMoreInvoices.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(getFullList.fulfilled, (state, { payload }) => {
      state.error = "";
      state.invoicesList = state.invoicesList.sort(function (a, b) {
        return a.id - b.id;
      });
      state.loading = "loaded";
    });
    builder.addCase(getFullList.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchInvoiceByID.pending, (state) => {
      state.invoice = {};
      // state.loading = "loading";
    });
    builder.addCase(fetchInvoiceByID.fulfilled, (state, { payload }) => {
      state.invoice = payload;
      state.invoicesList = [payload];
      // state.loading = "loaded";
    });
    builder.addCase(fetchInvoiceByID.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(createInvoice.pending, (state) => {
      state.message = "";
      state.loading = "loading";
    });
    builder.addCase(createInvoice.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(createInvoice.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
  },
});

// Action creators are generated for each case reducer function
export const { setInvoice, setViewing, setLastQuery, setInvoicesAmount } =
  invoicesSlice.actions;

export const selectInvoices = createSelector(
  (state) => ({
    invoices: state.invoices,
    invoice: state.invoices.invoice,
    invoicesList: state.invoices.invoicesList,
    loading: state.invoices.loading,
    message: state.invoices.message,
    error: state.invoices.error,
    viewing: state.invoices.viewing,
    invoicesAmount: state.invoices.invoicesAmount,
    lastQuery: state.invoices.lastQuery,
  }),
  (state) => state
);
export default invoicesSlice.reducer;
